import { Badge } from "@shopify/polaris";
import { ArrowDownIcon, ArrowUpIcon } from "@shopify/polaris-icons";
import { Tone } from "@shopify/polaris/build/ts/src/components/Badge";

import { LeakedCodes } from "../LeakedCodePageQuery";

export const UsagePeriodsComparisonBadge = ({ leakedCode }: { leakedCode: LeakedCodes["leakedCodes"][number] }) => {
  const arrow = leakedCode.percentageDifference > 0 ? ArrowUpIcon : ArrowDownIcon;
  const tone: Tone | undefined = leakedCode.percentageDifference > 0 ? "warning" : undefined;

  const formatPercentageChange = (percentage: number) => {
    if (isNaN(percentage)) {
      return "0";
    }

    return percentage.toFixed(0);
  };

  return (
    // @ts-expect-error issue with tone not accepting explicit undefined
    <Badge icon={arrow} tone={tone}>
      {formatPercentageChange(leakedCode.percentageDifference)}%
    </Badge>
  );
};
